import { useGetList } from "ra-core";

import type { Contact, ContactNote } from "../types";
import { DashboardActionItems } from "./DashboardActionItems";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardStepper } from "./DashboardStepper";
import { RecentClientCalls } from "./RecentClientCalls";
import { Welcome } from "./Welcome";

export const Dashboard = () => {
  const {
    data: dataContact,
    total: totalContact,
    isPending: isPendingContact,
  } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });

  const { total: totalContactNotes, isPending: isPendingContactNotes } =
    useGetList<ContactNote>("contact_notes", {
      pagination: { page: 1, perPage: 1 },
    });

  const isPending = isPendingContact || isPendingContactNotes;

  if (isPending) {
    return null;
  }

  if (!totalContact) {
    return <DashboardStepper step={1} />;
  }

  if (!totalContactNotes) {
    return <DashboardStepper step={2} contactId={dataContact?.[0]?.id} />;
  }

  return (
    <div className="flex flex-col gap-6 mt-1">
      {import.meta.env.VITE_IS_DEMO === "true" ? <Welcome /> : null}
      <div
        className="grid grid-cols-1 lg:grid-cols-12 gap-6"
        ref={(el) => {
          if (!el) return;
          const top = el.getBoundingClientRect().top;
          el.style.height = `calc(100dvh - ${top + 16}px)`;
        }}
      >
        <div className="lg:col-span-4 min-h-0">
          <DashboardActivityLog />
        </div>
        <div className="lg:col-span-4 min-h-0">
          <RecentClientCalls />
        </div>
        <div className="lg:col-span-4 min-h-0">
          <DashboardActionItems />
        </div>
      </div>
    </div>
  );
};
